import { render, staticRenderFns } from "./CustomsDeclarationPreviewDialog.vue?vue&type=template&id=0b19b574&scoped=true"
import script from "./CustomsDeclarationPreviewDialog.vue?vue&type=script&lang=ts"
export * from "./CustomsDeclarationPreviewDialog.vue?vue&type=script&lang=ts"
import style0 from "./CustomsDeclarationPreviewDialog.vue?vue&type=style&index=0&id=0b19b574&prod&scoped=true&lang=scss"
import style1 from "./CustomsDeclarationPreviewDialog.vue?vue&type=style&index=1&id=0b19b574&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b19b574",
  null
  
)

export default component.exports